var map = {
	"./en.ts": [
		74932
	],
	"./es.ts": [
		8223,
		223
	],
	"./zh-CHS.ts": [
		40504,
		504
	],
	"./zh-TW.ts": [
		6591,
		591
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36521;
module.exports = webpackAsyncContext;